import CourseDetail from './CourseDetail'

const CourseDetailPage = () => {
  return <CourseDetail />
}

export default CourseDetailPage 